import React from 'react'

import styles from './progressLoadingBar.module.scss'

type Props = {
  completionPercentage: number // This number as a number between 0 and 1
  label?: string
  className?: string
}

const ProgressLoadingBar = ({ label, completionPercentage, className = '' }: Props) => (
  <div className={`${styles.bar} ${className}`}>
    <div className={styles.progress} style={{ width: `${completionPercentage * 100}%` }} />
    <span className={styles.text}>{label}</span>
  </div>
)

export default ProgressLoadingBar
